import React from 'react';
import { Switch, Route } from 'react-router-dom';
import SchoolRollContainer from './containers/school-roll/index';
import QuickUploadContainer from './containers/quick-upload';
import AssignUser from './containers/assign-user/index';
import EditClass from './containers/edit-class/index';
import EditTeachers from './containers/edit-teacher/index';
import EditStudent from './containers/edit-student/index';
import RollOverContainer from './containers/roll-over';
import ExtendResultContainer from './containers/extend-result/index';
import DownloadCertificatesContainer from './containers/download-certificates/index';
import ManageDefaultCourses from './containers/manage-default-courses/manage-default-courses';
import ManageAssignedCourses from './containers/manage-assigned-courses/manage-assigned-courses';
import SignInCardsContainer from './containers/sign-in-cards/index';
import TeacherViewContainer from './containers/teacher-view/index';

const Routes = () => (
    <Switch>
        <Route component={ManageDefaultCourses} path="/manage-default-courses" />
        <Route component={ManageAssignedCourses} path="/manage-assigned-courses" />
        <Route
            component={DownloadCertificatesContainer}
            path="/download-certificates"
        />
        <Route component={SignInCardsContainer} path="/sign-in-cards" />
        <Route component={TeacherViewContainer} path="/teacher-view" />
        <Route component={ExtendResultContainer} path="/extend-result" />
        <Route component={RollOverContainer} path="/rollover" />
        <Route component={QuickUploadContainer} path="/quickUpload" />
        <Route component={AssignUser} path="/assign-user/:id/:assignType" />
        <Route component={EditClass} path="/edit-class/:classroomId" />
        <Route component={EditTeachers} path="/edit-teacher/:id" />
        <Route component={EditStudent} path="/edit-student/:id" />
        <Route component={SchoolRollContainer} path="/" />
    </Switch>
);

export default Routes;



// WEBPACK FOOTER //
// ./app/routes.js